import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import LogisticsOrdersTable from "@/components/logistics/orders/logistics-orders-table";

const ordersSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  paymentStatus: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/logistics/orders/")({
  validateSearch: ordersSearchSchema,
  component: LogisticsOrdersPage,
});

function LogisticsOrdersPage() {
  const searchParams = Route.useSearch();

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <LogisticsOrdersTable
        currentPage={searchParams.page}
        pageSize={10}
        basePath="/logistics/orders"
        searchParams={searchParams}
      />
    </div>
  );
}
